import React from 'react';
import PropTypes from 'prop-types';
import { Check, AlertTriangle } from 'lucide-react';

const QuizFeedback = ({ response }) => {
  if (!response) return null;

  return (
    <div
      className={`p-4 rounded-lg mb-6 ${
        response.isCorrect
          ? 'bg-green-50 border border-green-200'
          : 'bg-red-50 border border-red-200'
      }`}
    >
      <div className="flex items-center gap-2 mb-2">
        {response.isCorrect ? (
          <Check className="text-green-600" />
        ) : (
          <AlertTriangle className="text-red-600" />
        )}
        <span
          className={`font-semibold ${
            response.isCorrect
              ? 'text-green-600'
              : 'text-red-600'
          }`}
        >
          {response.isCorrect ? '正解です！' : '不正解です'}
        </span>
      </div>
      {response.explanation && (
        <p className="text-gray-600 whitespace-pre-line">
          {response.explanation}
        </p>
      )}
      <p className="text-gray-600 mt-2">
        正解: {response.correctAnswer}
      </p>
    </div>
  );
};

QuizFeedback.propTypes = {
  response: PropTypes.object,
};

export default QuizFeedback; 